import type { StaticSharedField } from './types';
import {
  ERR_TYPE_REQUIRED,
  ERR_TYPE_STR_LONG,
  ERR_TYPE_STR_SHORT,
  FIELD_TYPE_TXT,
} from '/business/shared/components/questions/helper/fieldEnums';

export default function useVehiclesSharedText({
  propName,
  label,
  errMsg,
}: {
  propName: string;
  label: string;
  errMsg?: string;
}): StaticSharedField {
  return {
    type: FIELD_TYPE_TXT,
    label: `${label}`,
    propName: propName,
    element: propName,
    validation: [
      {
        rule: ERR_TYPE_REQUIRED,
        errCode: `ERRNOVEHICLESHARED${label.toUpperCase().replace(' ', '')}`,
        errStr: `${errMsg || `Please provide a valid ${label}`}`,
      },
      {
        rule: ERR_TYPE_STR_SHORT,
        errCode: `ERRVEHICLESHAREDTOOSHORT${label.toUpperCase().replace(' ', '')}`,
        errStr: `${errMsg || `${label.charAt(0).toUpperCase() + label.slice(1)} too short`}`,
        value: 3,
      },
      {
        rule: ERR_TYPE_STR_LONG,
        errCode: `ERRVEHICLESHAREDTOOLONG${label.toUpperCase().replace(' ', '')}`,
        errStr: `${errMsg || `${label.charAt(0).toUpperCase() + label.slice(1)} too long`}`,
        value: 300,
      },
    ],
  };
}
